<template>
  <div class="p-0" style="margin-top: 15px;">
    <div class="checkboxes-title-wrapper" @click="isUnwrapped = !isUnwrapped">
      <strong>{{ title }}</strong>
      <img
        src="../../icons/dod/dodArrowIcon.svg"
        alt="Arrow icon"
        class="checkboxes-arrow"
        :class="{ 'transformed-arrow': !isUnwrapped }"
      />
    </div>
    <div v-if="isUnwrapped" class="checkboxes-wrapper">
      <div v-for="option in options" :key="option.id" class="checkbox-item">
        <input
          type="checkbox"
          :id="option.id"
          @change="(e) => handleCheck(option)"
        />
        <label :for="option.id">{{ option.name }}</label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ["onClick"],
  data() {
    return {
      isUnwrapped: false,
      checkedItems: [],
    };
  },
  methods: {
    handleCheck(val) {
      if (this.checkedItems.find((e) => e.id === val.id)) {
        this.checkedItems = this.checkedItems.filter(
          (elem) => elem.id !== val.id
        );
      } else {
        this.checkedItems.push(val);
      }
      this.$emit("onClick", this.checkedItems);
    },
  },
};
</script>

<style scoped>
strong {
  color: #090741;
  font-size: 12px;
}
.checkboxes-title-wrapper {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.checkboxes-arrow {
  transition: 0.5s;
}
.transformed-arrow {
  transform: rotate(180deg);
}
.checkboxes-wrapper {
  display: flex;
  flex-direction: column;
  padding: 0;
}
.checkbox-item {
  display: flex;
  gap: 10px;
  align-items: center;
}
.checkbox-item label {
  width: 100%;
  margin-bottom: 0;
  font-size: 12px;
  cursor: pointer;
}
input[type="checkbox"] {
  position: relative;
  width: 20px;
  height: 20px;
  appearance: none;
  background-color: transparent;
  outline: none;
}

input[type="checkbox"]::after {
  content: "";
  width: 18px;
  height: 18px;
  position: absolute;
  top: 0;
  left: 0;
  background: white;
  border: 1px solid #090741;
  border-radius: 4px;
}

input[type="checkbox"]:checked::after {
  content: "";
  display: inline-block;
  border: unset;
  background: linear-gradient(
    90deg,
    rgba(251, 134, 42, 1) 0%,
    rgba(241, 76, 82, 1) 49%,
    rgba(229, 8, 129, 1) 100%
  );
}

input[type="checkbox"]:checked::after {
  content: "✔";
  font-size: 14px;
  line-height: 18px;
  text-align: center;
  color: white;
}
</style>
